const screenInputData = {
  AddBasketPopUp: [{"name":"ItemId","type":"Guid","cardinality":1,"isExpandedPanel":null},{"name":"CardHeaderId","type":"Guid","cardinality":1,"isExpandedPanel":null}],
	AddBasketBarcodePopUp: [{"name":"ItemCode","type":"String","cardinality":1,"isExpandedPanel":null},{"name":"CartHeaderId","type":"Guid","cardinality":1,"isExpandedPanel":null}],
	CustomerDetail: [{"name":"CurAccCode","type":"String","cardinality":1,"isExpandedPanel":null}],
	WarehouseTransferAddManuelItemPop: [{"name":"ItemId","type":"Guid","cardinality":1,"isExpandedPanel":null}],
	BasketReportsDetail: [{"name":"CartHeaderId","type":"Guid","cardinality":1,"isExpandedPanel":null}],
	StockCountInfo: [{"name":"InventoryCountID","type":"Guid","cardinality":1,"isExpandedPanel":null}],
	PaymentScreen: [{"name":"CartHeaderId","type":"Guid","cardinality":1,"isExpandedPanel":null}],
	ProductBasket: [{"name":"CartHeaderId","type":"Guid","cardinality":1,"isExpandedPanel":null}],
	UserEdit: [{"name":"KUserId","type":"Guid","cardinality":1,"isExpandedPanel":null}],
	ProductDetail: [{"name":"ItemCode","type":"String","cardinality":1,"isExpandedPanel":null},{"name":"CartHeaderId","type":"Guid","cardinality":1,"isExpandedPanel":null}],
	StockCountDetail: [{"name":"StockCountHeaderId","type":"Guid","cardinality":1,"isExpandedPanel":null}],
	StockCountDetailEdit: [{"name":"SatirID","type":"Guid","cardinality":1,"isExpandedPanel":null}],
	CustomerDetailReport: [{"name":"CustomerName","type":"String","cardinality":1,"isExpandedPanel":null},{"name":"CustomerCode","type":"String","cardinality":1,"isExpandedPanel":null}],
	UserRoleManagement: [{"name":"KUserId","type":"Guid","cardinality":1,"isExpandedPanel":null},{"name":"UserName","type":"String","cardinality":1,"isExpandedPanel":null}],
	StockAddManuelItemCountPop: [{"name":"CountHeaderID","type":"Guid","cardinality":1,"isExpandedPanel":null},{"name":"ItemID","type":"Guid","cardinality":1,"isExpandedPanel":null}]
};

export class ScreenInputHelper {
  public static getScreenInputValue(screenName: string, inputName: string, value: string): any {
    switch (this.getScreenInputType(screenName, inputName)) {
      case "String":
        return value;
      case "Boolean":
        return value.toLowerCase() === "true";
      // TODO
    }

    return value;
  }

  private static getScreenInputType(screenName: string, inputName: string): string {
    const data = screenInputData[screenName]?.find((x) => x.Name === inputName);
    return data?.TypeName ? data.TypeName : "";
  }
}
